import React, { useContext } from "react";
import { Heading } from "react-aria-components";
import { t } from "ttag";

import type { ImageChooserBlockOrNull } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { ReactivatedContext } from "../../context";
import type { Favorite } from "../../favorites";
import { CenteredModalControlled } from "../CenteredModal";
import { ButtonSecondary } from "../Clickables";

import styles from "./index.module.scss";

interface Props {
    isOpen?: boolean;
    onOpenChange: (isOpen: boolean) => void;
    product: Favorite;
    image?: ImageChooserBlockOrNull;
}

export const AddedToFavoritesModal = ({
    isOpen = false,
    onOpenChange,
    product,
    image,
}: Props) => {
    const context = useContext(ReactivatedContext);
    const favoritesUrl = context.favorites_page_url;

    return (
        <CenteredModalControlled
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            theme="offWhite"
            overlay="light"
            panelClassName={styles.panel}
        >
            <Heading slot="title" className={styles.title}>
                {t`Added to Favorites`}
            </Heading>
            <div className={styles.productGroup}>
                {image && (
                    <ImageChooserBlock
                        value={image}
                        attrs={{ className: styles.picture }}
                        imageAttrs={{ className: styles.image, alt: "" }}
                        sizes="200px"
                    />
                )}
                <div className={styles.productInfo}>
                    <p className={styles.sku}>{product.sku}</p>
                    <p className={styles.productName}>{product.name}</p>
                </div>
            </div>
            {favoritesUrl && (
                <ButtonSecondary href={favoritesUrl}>
                    {t`Go to My Favorites`}
                </ButtonSecondary>
            )}
        </CenteredModalControlled>
    );
};
